import CustomerDTO from "features/customer/dtos/CustomerDTO";

export const setNameFormInitValues = (
  customer: CustomerDTO,
  setFormValue: (key: string, value: any, action?: "add" | "remove") => void
): void => {
  if (customer.customerType === "Person") {
    setFormValue("DESC_TMJMENOPUVODNI", customer.person?.firstName);
    setFormValue("DESC_TMJMENO", customer.person?.firstName);
    setFormValue("DESC_TMPRIJMENIPUVODNI", customer.person?.surname);
    setFormValue("DESC_TMPRIJMENI", customer.person?.surname);
  }
};
